module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-jj.c95af1b.png";